import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { IDocumentDetailRootDTO } from 'app/main/pages/documents/dto/document-details.dto';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { FieldActionEvent } from '../dynamic-field.component';
import { TranslocoService } from '@jsverse/transloco';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';

@Component({
  selector: 'app-document-key-field',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './document-key-field.component.html',
  styleUrl: './document-key-field.component.scss'
})
export class DocumentKeyFieldComponent {

  @Input() formGroup!: FormGroup;
  @Input() documentData: IDocumentDetailRootDTO;
  @Input() canEdit: boolean = true;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();
  @Input()
    set field(value: IField) {
      this._field = structuredClone(value);
    }
  
    get field(): IField {
      return this._field;
    }
  
  
  public _field: IField;


  public documentKeyType = [
    { id: 1, name: [this._translocoService.translate("Password - label (general) - Password")], value: 'password' },
    { id: 2, name: [this._translocoService.translate("PIN Via SMS option (Template/Document - section) - PIN Via SMS")], value: 'pin_code' },
    { id: 3, name: 'bankID', value: 'bank_id' }
  ];

  constructor(private _translocoService: TranslocoService) { }


  onDocumentKeyChange(value: boolean): void {
    this.actionEmit.emit({ action: 'onDocumentKeyChange', data: value });
  }

  onDocumentKeyTypeChange(value: string): void {
    this.actionEmit.emit({ action: 'onDocumentKeyTypeChange', data: value });
  }

  onDKPasswordChange(value: string): void {
    this.actionEmit.emit({ action: 'onDKPasswordChange', data: value });
  }

  onDKPasswordHintChange(value: string): void {
    this.actionEmit.emit({ action: 'onDKPasswordHintChange', data: value });
  }

  onDKSendViaSMSChange(value: boolean): void {
    this.actionEmit.emit({ action: 'onDKSendViaSMSChange', data: value });
  }

}
